<h1 mat-dialog-title>Add Price</h1>

<mat-dialog-content>
	<label>Weight <em>(whole number in grams)</em></label>
	<div class="input-group mb-3">
		<input [(ngModel)]="price.weight" type="number" step="1" class="form-control" placeholder="0" />
	</div>
	<label>Amount</label>
	<div class="input-group mb-3">
		<input [(ngModel)]="price.amount" type="text" class="form-control" placeholder="0.00" />
	</div>
	<label>Description</label>
	<div class="input-group mb-3">
		<textarea [(ngModel)]="price.description" class="form-control" rows="5"></textarea>
	</div>

</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close>Cancel</button>
	<button mat-button (click)="save()" cdkFocusInitial>Save</button>
</mat-dialog-actions>